import { render, staticRenderFns } from "./CustomColorTag.vue?vue&type=template&id=f85ea2d8&scoped=true&"
import script from "./CustomColorTag.vue?vue&type=script&lang=js&"
export * from "./CustomColorTag.vue?vue&type=script&lang=js&"
import style0 from "./CustomColorTag.vue?vue&type=style&index=0&id=f85ea2d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85ea2d8",
  null
  
)

export default component.exports